import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPopupType } from '../../../../shared/common/models/modalPopupType';

@Component({
  standalone: false,
  selector: 'warning-popup-project',
  templateUrl: './warning-popup-project.component.html',
  styleUrls: ['./warning-popup-project.component.scss']
})
export class WarningPopupProjectComponent implements OnInit {

    @ViewChild('template') template: TemplateRef<any>;
    @Output() clickedYes = new EventEmitter<any>();
    @Output() clickedCancel = new EventEmitter<any>();
    @Input() message: string;
    @Input() submessage: string;
    modalType: ModalPopupType;
    modalRef: BsModalRef;
    config = {
        animated: true,
        class: 'modal-dialog-centered'
    };

    constructor(private bsModalService: BsModalService) { }

    ngOnInit(): void {
    }

    show() {
        this.modalRef = this.bsModalService.show(this.template, this.config)
    }

    yes() {
        this.clickedYes.emit();
        this.modalRef.hide();
    }

    cancel() {
        this.modalRef.hide();
    }



}
